export interface ResponseDTO {
  body: unknown;
}

export let isResponseDTO = (variable: unknown): variable is ResponseDTO => {
  return (
    typeof variable === "object" &&
    variable !== undefined &&
    variable !== null &&
    "body" in variable
  );
};
